import React from 'react';
import { FieldDefinition } from './FieldRenderer';

interface DynamicEmailFieldProps {
  field: FieldDefinition;
  value: any;
  onChange: (fieldKey: string, value: any) => void;
  error?: string;
  disabled?: boolean;
  isArabic: boolean;
}

const DynamicEmailField: React.FC<DynamicEmailFieldProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
  isArabic
}) => {
  const label = isArabic ? field.label_ar || field.label : field.label;
  const placeholder = isArabic ? field.placeholder_ar || field.placeholder : field.placeholder;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(field.key, e.target.value);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        type="email"
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder || 'example@domain.com'}
        disabled={disabled}
        required={field.required}
        className={`w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          error ? 'border-red-500' : 'border-gray-300'
        } ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default DynamicEmailField;